import authHeader from "./auth-header";
import instance from "./ApiServices";

const getAll = (id) => {
  return instance.get(`/orders?page=${id}`, { headers: authHeader() });
};

const userorders = (user) => {
  return instance.get(`/ordersuser`, { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/orders/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/orders", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/orders/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/orders/${id}`, { headers: authHeader() });
};

// const removeAll = () => {
//   return instance.delete(`/orders`);
// };

const findByTitle = (title) => {
  return instance.get(`/orders?title=${title}`);
};

const PlaceOrdersService = {
  getAll,
  get,
  create,
  update,
  remove,
  findByTitle,
  userorders,
};

export default PlaceOrdersService;
